import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import BCNForm from '../Forms/BCNForm';

const AddEditBCNModal = ({
	bcn_code,
	normative_id,
	isOpen,
	isEdit,
	handleToggleModalBCN,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModalBCN}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModalBCN}>
				Resultado Ley Chile - Id BCN: {bcn_code}
			</ModalHeader>

			{/* <div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>Artículos</NavLink>
					</NavItem>
				</Nav>
			</div> */}

			<BCNForm
				bcn_code={bcn_code}
				normative_id={normative_id}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModalBCN={handleToggleModalBCN}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditBCNModal;
